import {styled} from "@mui/material";

export const PieChart = styled('div')({
  marginRight: 15,
  width: '40%',
});
